import { Application } from "@abaco/web-common/src/app";
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import WebComponents /*, { setI18N } */ from "@abaco/web-components/src/components";
import PortalVue from 'portal-vue';
import Vue from 'vue';
import App from "./App.vue";
import MaltaCustomerPortalModule from './modules/malta-customer-portal';
import GlobalFields from '../src/modules/malta-customer-portal/mixins/GlobalFields'
require('./assets/styles/themes/default.scss');

// eslint-disable-next-line no-console
console.clear();
// eslint-disable-next-line no-console
console.log("%cMalta Customer Portal v" + process.env.VUE_APP_VERSION + "-" + process.env.VUE_APP_GIT_COMMIT, "background:#86BC40;color:white;padding:20px;font-size:24px;border-radius:8px;");

new GlobalFields();


Vue.use(WebComponents);

Vue.use(PortalVue)


Vue.config.productionTip = false;

export const abacoApp = new Application({
    http: new HTTPClient(),

});


abacoApp.add(new MaltaCustomerPortalModule());

abacoApp.start((h) => h(App))
    .then((vue) => vue.$mount('#app'))
    .catch((err) => {
        console.error(err);
        alert("An error has occurred");
    });
